import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MediaObserver } from '@angular/flex-layout';

@Component({
  selector: 'esc-single-image-viewer',
  templateUrl: './single-image-viewer.component.html',
  styleUrls: ['./single-image-viewer.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),

      state('rotateLeft1', style({ transform: 'rotate(-90deg)' })),
      state('rotateLeft2', style({ transform: 'rotate(-180deg)' })),
      state('rotateLeft3', style({ transform: 'rotate(-270deg)' })),
      state('rotateLeft4', style({ transform: 'rotate(-360deg)' })),
      // transition('default => rotateLeft1', animate('400ms ease-in')),
      // transition('rotateLeft1 => rotateLeft2', animate('400ms ease-in')),
      // transition('rotateLeft2 => rotateLeft3', animate('400ms ease-in')),
      // transition('rotateLeft3 => rotateLeft4', animate('400ms ease-in')),
      // transition('rotateLeft4 => default', animate('400ms ease-in')),

      state('rotateRight1', style({ transform: 'rotate(90deg)' })),
      state('rotateRight2', style({ transform: 'rotate(180deg)' })),
      state('rotateRight3', style({ transform: 'rotate(270deg)' })),
      state('rotateRight4', style({ transform: 'rotate(360deg)' })),
      // transition('default => rotateRight1', animate('400ms ease-in')),
      // transition('rotateRight1 => rotateRight2', animate('400ms ease-in')),
      // transition('rotateRight2 => rotateRight3', animate('400ms ease-in')),
      // transition('rotateRight3 => rotateRight4', animate('400ms ease-in')),
      // transition('rotateRight4 => default', animate('400ms ease-in')),
    ])
  ]
})
export class SingleImageViewerComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SingleImageViewerComponent>,
  ) { }

  state: string = 'default';
  public loading = {
    image: true,
    error: false,
  }

  ngOnInit() {
    // console.log(this.data);
  }

  rotateLeft() {
    switch(this.state) {
      case 'default': {
        this.state = 'rotateLeft1';
        break;
      }
      case 'rotateLeft1': {
        this.state = 'rotateLeft2';
        break;
      }
      case 'rotateLeft2': {
        this.state = 'rotateLeft3';
        break;
      }
      case 'rotateLeft3': {
        this.state = 'rotateLeft4';
        break;
      }
      case 'rotateLeft4': {
        this.state = 'default';
        this.state = 'rotateLeft1';
        break;
      }

      case 'rotateRight1': {
        this.state = 'default';
        break;
      }
      case 'rotateRight2': {
        this.state = 'rotateLeft3';
        break;
      }
      case 'rotateRight3': {
        this.state = 'rotateLeft2';
        break;
      }
      case 'rotateRight4': {
        this.state = 'rotateLeft1';
        break;
      }
    }
  }

  rotateRight() {
    switch(this.state) {
      case 'default': {
        this.state = 'rotateRight1';
        break;
      }
      case 'rotateRight1': {
        this.state = 'rotateRight2';
        break;
      }
      case 'rotateRight2': {
        this.state = 'rotateRight3';
        break;
      }
      case 'rotateRight3': {
        this.state = 'rotateRight4';
        break;
      }
      case 'rotateRight4': {
        this.state = 'default';
        this.state = 'rotateRight1';
        break;
      }

      case 'rotateLeft1': {
        this.state = 'default';
        break;
      }
      case 'rotateLeft2': {
        this.state = 'rotateRight3';
        break;
      }
      case 'rotateLeft3': {
        this.state = 'rotateRight2';
        break;
      }
      case 'rotateLeft4': {
        this.state = 'rotateRight1';
        break;
      }
    }
  }

  loadingImage() {
    this.loading.image = false;
  }

  imageUrlError(ev) {
    // console.log(ev);
    this.loading.image = false;
    this.loading.error = true;
  }

}